import { StorageService } from "./LocalStorageService";
import { showInvitePromo } from "../utils/promo/InvitePromo";
import ApiService from "../handlers/apiService";
import { BookPromoService } from "./BookPromoService";

/**
 * Service responsible for gating and showing the Invite Promo modal.
 *
 * Rules:
 * - Same relation to onboarding/first-time user as Special Deals (i.e., not shown on the first-ever session when onboarding runs)
 * - Show only for users who have invited 0 users
 * - If both Invite Promo and Book Promo are eligible, Invite Promo shows first, then Book Promo after closing
 */
export class InvitePromoService {
  private static hasCheckedThisSession = false;

  static async checkAndShowInvitePromo(): Promise<void> {
    if (this.hasCheckedThisSession) return;
    this.hasCheckedThisSession = true;

    try {
      // Do not show if already shown today
      if (StorageService.hasInvitePromoBeenShownToday()) {
        BookPromoService.checkAndShowBookPromo();
        return;
      }

      // Same relation to onboarding as Special Deals: skip on true first-time (no last visit)
      const lastVisit = StorageService.getLastVisitTime();
      if (!lastVisit) {
        BookPromoService.checkAndShowBookPromo();
        return;
      }

      // Fetch invite stats to ensure user has invited no one
      const api = ApiService.getInstance();
      const stats = await api.api.usersInviteStatsList();
      if (stats && stats.usersInvited === 0) {
        // Eligible → show Invite Promo first
        showInvitePromo();
        // Then trigger Book Promo check which will queue it (ModalManager will handle order)
        BookPromoService.checkAndShowBookPromo();
      } else {
        BookPromoService.checkAndShowBookPromo();
      }
    } catch (error) {
      console.error("InvitePromoService: failed to check/show promo", error);
      try {
        BookPromoService.checkAndShowBookPromo();
      } catch {}
    }
  }
}

export default InvitePromoService;
